import module from './gift-deets.module';
import moment from 'moment';

module.controller('GiftDeetsController', [
  'AppService',
  'CurrentUserService',
  'FriendsService',
  'GiftDetailsService',
  'GiftCommentsService',
  '$stateParams',
  '$state',
  '$timeout',
  '$rootScope',
  '$scope',
  function (
    AppService,
    CurrentUserService,
    FriendsService,
    GiftDetailsService,
    GiftCommentsService,
    $stateParams,
    $state,
    $timeout,
    $rootScope,
    $scope
  ) {
    var ctrl = this;
    ctrl.saveButtonText = 'Save';
    ctrl.saving = false;
    ctrl.showEditTray = false;

    var inEditMode = false;
    var commentLoaderInterval;

    AppService.pageTitle = 'Gift Details';
    ctrl.isNew = false;

    $rootScope.$on('force-check-auth', function () {
      clearInterval(commentLoaderInterval);
    });

    $scope.$on('$destroy', function () {
      clearInterval(commentLoaderInterval);
    });

    ctrl.toggleEditTray = function () {
      ctrl.showEditTray = !ctrl.showEditTray;
    };

    ctrl.showEditTrayForDelete = function () {
      ctrl.showEditTray = true;
      ctrl.editTrayPurpose = 'delete';
    };

    ctrl.showEditTrayForUnbuy = function () {
      ctrl.showEditTray = true;
      ctrl.editTrayPurpose = 'unbuy';
    };

    ctrl.canShowDelete = function () {
      if (ctrl.wasSuggestedByCurrentUser()) {
        if (ctrl.giftIsForSelf()) {
          return true;
        } else {
          if (ctrl.boughtByYou()) {
            return true;
          }

          if (ctrl.boughtBySomeoneElse()) {
            return false;
          }
          return true;
        }
      } else {
        return false;
      }
    };

    ctrl.deleteGift = function () {
      ctrl.toggleEditTray();

      GiftDetailsService.deleteGift(ctrl.details).then(function () {
        goToGiftListForPerson();
      });
    };

    function goToGiftListForPerson() {
      if (ctrl.giftIsForSelf()) {
        $state.go('me');
      } else {
        $state.go('gift-list', { friendId: ctrl.details.giftFor });
      }
    }

    ctrl.unbuyGift = function () {
      ctrl.toggleEditTray();

      GiftDetailsService.unbuyGift(ctrl.details).then(function () {
        ctrl.details.boughtBy = null;
      });
    };

    ctrl.showCanUnbuy = function () {};

    var addAutosizeToTextArea = function (elementSelector) {
      var ta = document.querySelector(elementSelector);
      autosize(ta);
      ta.style.display = 'none';
      autosize(ta);
      ta.style.display = '';

      // Call the update method to recalculate the size:
      autosize.update(ta);
    };
    $timeout(function () {
      addAutosizeToTextArea('.gift-deets-page textarea.new-comment');
    }, 0);

    ctrl.wasSuggestedByCurrentUser = function () {
      if (ctrl.details) {
        return CurrentUserService.currentUser.id === ctrl.details.suggestedBy;
      }
      return false;
    };

    ctrl.giftIsForSelf = function () {
      return ctrl.details && ctrl.details.giftFor == CurrentUserService.currentUser.id;
    };

    ctrl.makeEditable = function () {
      if (ctrl.wasSuggestedByCurrentUser() || ctrl.isNew) {
        inEditMode = true;

        $timeout(function () {
          addAutosizeToTextArea('.gift-deets-page textarea.gift-description');
          addAutosizeToTextArea('.gift-deets-page textarea.gift-name');
        }, 0);
      }
    };

    if ($state.current.isNewIdea) {
      ctrl.isNew = true;
      ctrl.details = {};
      ctrl.makeEditable();

      var giftForId = Number($stateParams.friendId);
      if (!giftForId) {
        giftForId = CurrentUserService.currentUser.id;
      }
      ctrl.details.giftFor = giftForId;

      if (giftForId == CurrentUserService.currentUser.id) {
        ctrl.friend = CurrentUserService.currentUser;
      } else {
        FriendsService.getFriendById(Number($stateParams.friendId)).then(function (data) {
          ctrl.friend = data;
        });
      }
    }

    ctrl.markGiftAsBought = function () {
      ctrl.markingAsBought = true;
      ctrl.snipedByAnother = false;

      GiftDetailsService.markAsBought(ctrl.details).then((response) => {
        if (response.success) {
          ctrl.details.boughtBy = CurrentUserService.currentUser.id;
          ctrl.markingAsBought = false;
        } else {
          ctrl.snipedByAnother = true;
          ctrl.details.boughtBy = 999999;
        }
      });
    };

    ctrl.saveGiftIdea = function () {
      ctrl.giftNameRequiredError = false;

      // do some validation first
      if (!ctrl.details || !ctrl.details.giftName || !ctrl.details.giftName.trim()) {
        ctrl.giftNameRequiredError = true;
        return;
      }

      ctrl.saveButtonText = 'Saving...';
      ctrl.saving = true;

      GiftDetailsService.save({
        id: ctrl.details.id,
        giftName: ctrl.details.giftName,
        description: ctrl.details.description,
        price: ctrl.details.price,
        giftFor: ctrl.details.giftFor ? ctrl.details.giftFor : ctrl.friend.id,
      }).then(function (result) {
        if (ctrl.isNew) {
          goToGiftListForPerson();
        } else {
          ctrl.saveButtonText = 'Save';
          ctrl.saving = false;
          inEditMode = false;
        }
      });
    };

    ctrl.isEditable = function () {
      if (inEditMode) {
        return true;
      }
      if (ctrl.isNew) {
        return true;
      }
      return false;
    };

    ctrl.isReadOnly = function () {
      return !ctrl.isEditable();
    };

    //OTHER
    var giftId = $stateParams.giftId;

    this.newComment;

    this.addNewGift = function () {
      this.isNew = false;
    };

    ctrl.loadComments = function () {
      GiftCommentsService.getComments(giftId).then(function (data) {
        ctrl.comments = data;
      });
    };

    if (!ctrl.isNew) {
      GiftDetailsService.getDetails(giftId).then(function (data) {
        ctrl.details = data;

        FriendsService.getFriendById(data.giftFor).then(function (friend) {
          ctrl.friend = friend;
        });
      });

      ctrl.loadComments();

      if (!commentLoaderInterval) {
        commentLoaderInterval = setInterval(ctrl.loadComments, 15000);
      }

      this.addNewComment = function (newComment) {
        if (!newComment) {
          return;
        }

        ctrl.savingComment = true;
        var newCommentObject = {
          giftId: giftId,
          body: newComment,
          commentBy: CurrentUserService.currentUser.name,
          commentById: CurrentUserService.currentUser.id,
          createdDateTime: new Date().toISOString(),
        };

        GiftCommentsService.addComment(newCommentObject).then(function (result) {
          ctrl.comments.unshift(newCommentObject);
          ctrl.newComment = '';
          ctrl.savingComment = false;
        });
      };
    }

    this.getRelativeTime = function (dt) {
      return moment(dt).fromNow();
    };

    this.boughtByYou = function () {
      var gift = ctrl.details;

      if (!gift) return false;
      return gift.boughtBy && gift.boughtBy === CurrentUserService.currentUser.id;
    };

    this.boughtBySomeoneElse = function () {
      var gift = ctrl.details;

      if (!gift) return false;
      if (gift.boughtBy && gift.boughtBy !== CurrentUserService.currentUser.id) {
        return true;
      }
      return false;
    };

    this.boughtByMessage = function () {
      if (ctrl.boughtByYou()) {
        return 'You bought this.';
      } else if (ctrl.boughtBySomeoneElse()) {
        return 'Someone else already bought this.';
      }
    };
  },
]);
